<template>
  <v-container style="max-width: 500px">

    <div>
      <div v-if="!organisation">
        <v-btn 
        block
        v-if="!createOrg"
        @click="createOrg = true"
        height="60"
        color="warning"
        >
          <v-icon left>
            mdi-alert
          </v-icon>
          Create organisation
        </v-btn>

        <create_organisation 
        v-else
        @orgCreated="createOrg = false" />
      </div>

      <v-card v-else>
        <v-card-title primary-title>
          {{organisation.organisationName}}
        </v-card-title>
        <v-card-text>
          DBMS: <b>Snowflake</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="openWeb(organisation)" color="primary">Open Test manager</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>
</template>

<script>
  import { get } from 'vuex-pathify'
  import login from '../login.vue'
  import create_organisation from './create_organisation'
  import urljoin from 'url-join'

  export default {
    data() {
      return {
        createOrg: false,
      }
    },
    components: {login, create_organisation},
    methods: {
      async openWeb(organisation) {
        let url = process.env.VUE_APP_FRONTEND
        const backendUrl = process.env.VUE_APP_CONTAINERS.replace(/\/$/, '') 
          + "/"
          + organisation.port 
          + '/api/connection/check_installed'
        const isInstalled = await this.$axios(backendUrl)
        if (!isInstalled.data) {
          url = urljoin(url, "/installation", `?jwt=${organisation.jwt}`)
        }
        window.open(url, '_blank');
      },
    },
    computed: {
      organisation: get("organisation"),
      user: get("user"),
    },
  }
</script>

<style lang="scss" scoped>

</style>